import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState,useEffect } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '-',
        horaDefuncion: '',
        observaciones: '-',
        idLinea: '1',
        fallecido: {
            fechaFallecimiento: '',
            funeraria:'-',
            observaciones: '-',
            incidencias: '',
            historico: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [terceros, setTerceros] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [fallecidoExiste, setFallecidoExiste] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        async function fetchUltimoSepulturaId() {
            try {
                const response = await axios.get('/sepulturasc'); // Llamada al backend
                const sepulturas = response.data;

                if (sepulturas.length > 0) {
                    const sepulturasOrdenadas = sepulturas.sort((a, b) => b.id - a.id); // Ordena de mayor a menor
                    const ultimoId = sepulturasOrdenadas[0].id; // Toma el primero de la lista ordenada

                    setFormData(prevState => ({
                        ...prevState,
                        sepulturaId: ultimoId
                    }));
                }
            } catch (error) {
                console.error("Error obteniendo el último ID de sepultura:", error);
            }
        }

        fetchUltimoSepulturaId();
    }, []);






    useEffect(() => {
        const fetchTerceros = async () => {
            try {
                const response = await axios.get('/terceros');
                setTerceros(response.data);
            } catch (error) {
                console.error('Error al cargar los terceros:', error);
            }
        };
        fetchTerceros();
    }, []);

    const filteredTerceros = terceros.filter((tercero) => 
        tercero.documento.toLowerCase().includes(searchTerm.toLowerCase()) || 
        tercero.nombre.toLowerCase().includes(searchTerm.toLowerCase())
    );
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
     
    
    const verificarFallecido = async () => {
        try {
            const response = await axios.get(`/fallecidosc/tercero/${formData.terceroId}`);
    
            if (response.data) { // Si el backend devuelve un objeto válido
                setFallecidoExiste(true);
                return true; // Fallecido ya existe
            }
    
            setFallecidoExiste(false);
            return false; // No existe
        } catch (error) {
            console.error('Error al verificar fallecido:', error);
            setFallecidoExiste(false);
            return false; // Asumimos que no existe en caso de error
        }
    };
   

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        // Verificar si el fallecido ya está registrado
        const existe = await verificarFallecido();
        if (existe) {
            setIsLoading(false);
            return; // Detener el envío
        }
    
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0',
                    idLinea: '1'
                }
            };
            console.log('Payload enviado:', payload);
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };




/*   
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0',
                    idLinea: '1'
                }
            };
            console.log('Payload enviado:', payload);
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };
*/

    return (
        <div className="container mx-auto px-6 py-8">
            <h2 className="text-3xl font-semibold text-grey-600 mb-6 text-center">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-grey-100 shadow-lg rounded-lg p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) && (
                            <div key={key}>
                                <label className="block text-grey-700 font-medium mb-1" htmlFor={key}>
                                    {key.replace(/([A-Z])/g, ' $1').toLowerCase()
                                    .replace(/^./, (str) => str.toUpperCase())
                                    }
                                </label>
                                <input
                                    type={key.includes('fecha') ? 'date' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${key}`}
                                />
                            </div>
                        )
                    ))}

                     <div>
                        <label className="block text-grey-700 font-medium mb-1" htmlFor="terceroId">Tercero</label>

                        <input
                            type="text"
                            name="searchTerm"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                            placeholder="Buscar por documento o nombre"
                        />

                        <select
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleChange}
                            className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
>
                            <option value="">Seleccione un tercero</option>
                             {filteredTerceros.map((tercero) => (
                             <option key={tercero.id} value={tercero.documento}>
                             {tercero.documento} - {tercero.nombre}
                             </option>
                             ))}
                        </select>
                       
                    </div>

                    {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                        <div key={field}>
                            <label className="block text-grey-700 font-medium mb-1" htmlFor={field}>
                                {field.replace(/([A-Z])/g, ' $1').toLowerCase()
                                .replace(/^./, (str) => str.toUpperCase())
                                }
                            </label>

                            <input
                                type={field === 'horaDefuncion' ? 'datetime-local' : 'text'}
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                placeholder={`Ingrese ${field}`}
                            />
                        </div>
                        
                    ))}
                    {Object.keys(formData.fallecido).map((subKey) => (
                        !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                            <div key={subKey}>
                                <label className="block text-gray-700 font-medium mb-1" htmlFor={`fallecido.${subKey}}`}>
                                    {subKey.replace(/([A-Z])/g, ' $1').toLowerCase()
                                    .replace(/^./, (str) => str.toUpperCase())
                                    }
                                </label>
                                <input
                                    type={subKey.includes('fecha') ? 'date' : 'text'}
                                    name={`fallecido.${subKey}`}
                                    value={formData.fallecido[subKey]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${subKey}`}
                                />
                            </div>
                        )
                    ))}
                </div>

                {fallecidoExiste && (
                   <p className="text-red-500 text-center font-bold">
                       ⚠️ Este fallecido ya está registrado en el sistema.
                   </p>
              )}



                <div className="flex justify-center mt-6">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-black-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring focus:ring-blue-400"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}


/* sin control fallecido
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState,useEffect } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '-',
        horaDefuncion: '',
        observaciones: '-',
        idLinea: '1',
        fallecido: {
            fechaFallecimiento: '',
            funeraria:'-',
            observaciones: '-',
            incidencias: '',
            historico: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [terceros, setTerceros] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTerceros = async () => {
            try {
                const response = await axios.get('/terceros');
                setTerceros(response.data);
            } catch (error) {
                console.error('Error al cargar los terceros:', error);
            }
        };
        fetchTerceros();
    }, []);

    const filteredTerceros = terceros.filter((tercero) => 
        tercero.documento.toLowerCase().includes(searchTerm.toLowerCase()) || 
        tercero.nombre.toLowerCase().includes(searchTerm.toLowerCase())
    );
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
     
   
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0',
                    idLinea: '1'
                }
            };
            console.log('Payload enviado:', payload);
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-6 py-8">
            <h2 className="text-3xl font-semibold text-grey-600 mb-6 text-center">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-grey-100 shadow-lg rounded-lg p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) && (
                            <div key={key}>
                                <label className="block text-grey-700 font-medium mb-1" htmlFor={key}>
                                    {key.replace(/([A-Z])/g, ' $1').toLowerCase()
                                    .replace(/^./, (str) => str.toUpperCase())
                                    }
                                </label>
                                <input
                                    type={key.includes('fecha') ? 'date' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${key}`}
                                />
                            </div>
                        )
                    ))}

                     <div>
                        <label className="block text-grey-700 font-medium mb-1" htmlFor="terceroId">Tercero</label>

                        <input
                            type="text"
                            name="searchTerm"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                            placeholder="Buscar por documento o nombre"
                        />

                        <select
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleChange}
                            className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
>
                            <option value="">Seleccione un tercero</option>
                             {filteredTerceros.map((tercero) => (
                             <option key={tercero.id} value={tercero.documento}>
                             {tercero.documento} - {tercero.nombre}
                             </option>
                             ))}
                        </select>
                       
                    </div>

                    {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                        <div key={field}>
                            <label className="block text-grey-700 font-medium mb-1" htmlFor={field}>
                                {field.replace(/([A-Z])/g, ' $1').toLowerCase()
                                .replace(/^./, (str) => str.toUpperCase())
                                }
                            </label>

                            <input
                                type={field === 'horaDefuncion' ? 'datetime-local' : 'text'}
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                placeholder={`Ingrese ${field}`}
                            />
                        </div>
                        
                    ))}
                    {Object.keys(formData.fallecido).map((subKey) => (
                        !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                            <div key={subKey}>
                                <label className="block text-gray-700 font-medium mb-1" htmlFor={`fallecido.${subKey}}`}>
                                    {subKey.replace(/([A-Z])/g, ' $1').toLowerCase()
                                    .replace(/^./, (str) => str.toUpperCase())
                                    }
                                </label>
                                <input
                                    type={subKey.includes('fecha') ? 'date' : 'text'}
                                    name={`fallecido.${subKey}`}
                                    value={formData.fallecido[subKey]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${subKey}`}
                                />
                            </div>
                        )
                    ))}
                </div>
                <div className="flex justify-center mt-6">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-black-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring focus:ring-blue-400"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/



/* sale desplegable pero no incorpora el codigo
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState,useEffect } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '-',
        horaDefuncion: '',
        observaciones: '-',
        idLinea: '1',
        fallecido: {
            fechaFallecimiento: '',
            funeraria:'-',
            observaciones: '-',
            incidencias: '',
            historico: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [terceros, setTerceros] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTerceros = async () => {
            try {
                const response = await axios.get('/terceros');
                setTerceros(response.data);
            } catch (error) {
                console.error('Error al cargar los terceros:', error);
            }
        };
        fetchTerceros();
    }, []);



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
   
   
   
   
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0',
                    idLinea: '1'
                }
            };
            console.log('Payload enviado:', payload);
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-6 py-8">
            <h2 className="text-3xl font-semibold text-blue-600 mb-6 text-center">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) && (
                            <div key={key}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={key}>
                                    {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={key.includes('fecha') ? 'date' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${key}`}
                                />
                            </div>
                        )
                    ))}

                     <div>
                        <label className="block text-blue-700 font-medium mb-1" htmlFor="terceroId">TERCERO</label>
                        <select
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleChange}
                            className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                        >
                            <option value="">Seleccione un tercero</option>
                            {terceros.map((tercero) => (
                                <option key={tercero.id} value={tercero.id}>
                                    {tercero.documento} - {tercero.nombre}
                                </option>
                            ))}
                        </select>
                    </div>



                    {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                        <div key={field}>
                            <label className="block text-blue-700 font-medium mb-1" htmlFor={field}>
                                {field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type={field === 'horaDefuncion' ? 'datetime-local' : 'text'}
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                placeholder={`Ingrese ${field}`}
                            />
                        </div>
                        
                    ))}
                    {Object.keys(formData.fallecido).map((subKey) => (
                        !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                            <div key={subKey}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={`fallecido.${subKey}}`}>
                                    {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={subKey.includes('fecha') ? 'date' : 'text'}
                                    name={`fallecido.${subKey}`}
                                    value={formData.fallecido[subKey]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${subKey}`}
                                />
                            </div>
                        )
                    ))}
                </div>
                <div className="flex justify-center mt-6">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring focus:ring-blue-400"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/



/* CORRECTO
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '-',
        horaDefuncion: '',
        observaciones: '-',
        idLinea: '1',
        fallecido: {
            fechaFallecimiento: '',
            funeraria:'-',
            observaciones: '-',
            incidencias: '',
            historico: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
   
   
   
   
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0',
                    idLinea: '1'
                }
            };
            console.log('Payload enviado:', payload);
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-6 py-8">
            <h2 className="text-3xl font-semibold text-blue-600 mb-6 text-center">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) && (
                            <div key={key}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={key}>
                                    {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={key.includes('fecha') ? 'date' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${key}`}
                                />
                            </div>
                        )
                    ))}
                    {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                        <div key={field}>
                            <label className="block text-blue-700 font-medium mb-1" htmlFor={field}>
                                {field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type={field === 'horaDefuncion' ? 'datetime-local' : 'text'}
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                placeholder={`Ingrese ${field}`}
                            />
                        </div>
                    ))}
                    {Object.keys(formData.fallecido).map((subKey) => (
                        !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                            <div key={subKey}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={`fallecido.${subKey}}`}>
                                    {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={subKey.includes('fecha') ? 'date' : 'text'}
                                    name={`fallecido.${subKey}`}
                                    value={formData.fallecido[subKey]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${subKey}`}
                                />
                            </div>
                        )
                    ))}
                </div>
                <div className="flex justify-center mt-6">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring focus:ring-blue-400"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/


/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '',
        horaDefuncion: '',
        observaciones: '',
        idLinea: '1',
        fallecido: {
            fechaFallecimiento: '',
            incidencias: '',
            historico: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0',
                    idLinea: '1'
                }
            };
            console.log('Payload enviado:', payload);
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-6 py-8">
            <h2 className="text-3xl font-semibold text-blue-600 mb-6 text-center">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) && (
                            <div key={key}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={key}>
                                    {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={key.includes('fecha') ? 'date' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${key}`}
                                />
                            </div>
                        )
                    ))}
                    {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                        <div key={field}>
                            <label className="block text-blue-700 font-medium mb-1" htmlFor={field}>
                                {field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type={field === 'horaDefuncion' ? 'datetime-local' : 'text'}
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                placeholder={`Ingrese ${field}`}
                            />
                        </div>
                    ))}
                    {Object.keys(formData.fallecido).map((subKey) => (
                        !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                            <div key={subKey}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={`fallecido.${subKey}}`}>
                                    {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={subKey.includes('fecha') ? 'date' : 'text'}
                                    name={`fallecido.${subKey}`}
                                    value={formData.fallecido[subKey]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${subKey}`}
                                />
                            </div>
                        )
                    ))}
                </div>
                <div className="flex justify-center mt-6">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring focus:ring-blue-400"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/* CORRECTO
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '',
        horaDefuncion: '',
        observaciones: '',
        idLinea: '1',
        fallecido: {
            fechaFallecimiento: '',
            incidencias: '',
            historico: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0',
                    idLinea: '1'
                }
            };
            console.log('Payload enviado:', payload);
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-6 py-8">
            <h2 className="text-3xl font-semibold text-blue-600 mb-6 text-center">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) && (
                            <div key={key}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={key}>
                                    {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={key.includes('fecha') ? 'date' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${key}`}
                                />
                            </div>
                        )
                    ))}
                    {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                        <div key={field}>
                            <label className="block text-blue-700 font-medium mb-1" htmlFor={field}>
                                {field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type={field === 'horaDefuncion' ? 'datetime-local' : 'text'}
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                placeholder={`Ingrese ${field}`}
                            />
                        </div>
                    ))}
                    {Object.keys(formData.fallecido).map((subKey) => (
                        !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                            <div key={subKey}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={`fallecido.${subKey}}`}>
                                    {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={subKey.includes('fecha') ? 'date' : 'text'}
                                    name={`fallecido.${subKey}`}
                                    value={formData.fallecido[subKey]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${subKey}`}
                                />
                            </div>
                        )
                    ))}
                </div>
                <div className="flex justify-center mt-6">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring focus:ring-blue-400"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/
/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '',
        horaDefuncion: '',
        observaciones: '',
        idLinea: '1',
        fallecido: {
            fechaFallecimiento: '',
            incidencias: '',
            historico: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0',
                    idLinea: '1'
                }
            };
            console.log('Payload enviado:', payload);
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-6 py-8">
            <h2 className="text-3xl font-semibold text-blue-600 mb-6 text-center">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) && (
                            <div key={key}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={key}>
                                    {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={key.includes('fecha') ? 'date' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${key}`}
                                />
                            </div>
                        )
                    ))}
                    {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                        <div key={field}>
                            <label className="block text-blue-700 font-medium mb-1" htmlFor={field}>
                                {field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                placeholder={`Ingrese ${field}`}
                            />
                        </div>
                    ))}
                    {Object.keys(formData.fallecido).map((subKey) => (
                        !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                            <div key={subKey}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={`fallecido.${subKey}}`}>
                                    {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type={subKey.includes('fecha') ? 'date' : 'text'}
                                    name={`fallecido.${subKey}`}
                                    value={formData.fallecido[subKey]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${subKey}`}
                                />
                            </div>
                        )
                    ))}
                </div>
                <div className="flex justify-center mt-6">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring focus:ring-blue-400"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '',
        horaDefuncion: '',
        observaciones: '',
        idLinea: '1',
        fallecido: {
            fechaFallecimiento: '',
            incidencias: '',
            historico: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0',
                    idLinea: '1'
                }
            };
            console.log('Payload enviado:', payload);
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-6 py-8">
            <h2 className="text-3xl font-semibold text-blue-600 mb-6 text-center">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) && (
                            <div key={key}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={key}>
                                    {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type="text"
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${key}`}
                                />
                            </div>
                        )
                    ))}
                    {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                        <div key={field}>
                            <label className="block text-blue-700 font-medium mb-1" htmlFor={field}>
                                {field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={field}
                                value={formData[field]}
                                onChange={handleChange}
                                className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                placeholder={`Ingrese ${field}`}
                            />
                        </div>
                    ))}
                    {Object.keys(formData.fallecido).map((subKey) => (
                        !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                            <div key={subKey}>
                                <label className="block text-blue-700 font-medium mb-1" htmlFor={`fallecido.${subKey}}`}>
                                    {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                                </label>
                                <input
                                    type="text"
                                    name={`fallecido.${subKey}`}
                                    value={formData.fallecido[subKey]}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring focus:ring-blue-400"
                                    placeholder={`Ingrese ${subKey}`}
                                />
                            </div>
                        )
                    ))}
                </div>
                <div className="flex justify-center mt-6">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:ring focus:ring-blue-400"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/
/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '', // Campo único
        fecha: '',
        funeraria: '', // Campo único
        horaDefuncion: '', // Campo único
        observaciones: '', // Campo único
        idLinea: '1',
        fallecido: {
           // idLinea: '1',
            fechaFallecimiento: '',
            incidencias: '',
            historico: '',
            trasladoId: '0' // Valor por defecto, no se muestra en pantalla
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0', // Asegurar que se envía trasladoId
                    idLinea: '1' // Asegurar que se envía idLinea
                }
            };
            console.log('Payload enviado:', payload); // Depuración
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                {Object.keys(formData).map((key) => (
                    !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) ? (
                        <div className="mb-4" key={key}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={key}
                                value={formData[key]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${key}`}
                            />
                        </div>
                    ) : null
                ))}
                {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                    <div className="mb-4" key={field}>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={field}>
                            {field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                        </label>
                        <input
                            type="text"
                            name={field}
                            value={formData[field]}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            placeholder={`Ingrese ${field}`}
                        />
                    </div>
                ))}
                {Object.keys(formData.fallecido).map((subKey) => (
                    !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                        <div className="mb-4" key={subKey}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={`fallecido.${subKey}}`}>
                                {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={`fallecido.${subKey}`}
                                value={formData.fallecido[subKey]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${subKey}`}
                            />
                        </div>
                    )
                ))}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/
/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '', // Campo único
        fecha: '',
        funeraria: '', // Campo único
        horaDefuncion: '', // Campo único
        observaciones: '', // Campo único
        idLinea: '1',
        fallecido: {
            idLinea: '1',
            fechaFallecimiento: '',
            incidencias: '',
            historico: '',
            trasladoId: '0' // Valor por defecto, no se muestra en pantalla
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = { ...prevData };
            
            if (name.startsWith('fallecido.')) {
                const key = name.split('.')[1];
                updatedData = {
                    ...prevData,
                    fallecido: {
                        ...prevData.fallecido,
                        [key]: value
                    }
                };
            } else {
                updatedData = { ...prevData, [name]: value };
                if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                    updatedData.fallecido = {
                        ...prevData.fallecido,
                        [name]: value
                    };
                }
            }
            return updatedData;
        });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                ...formData,
                fallecido: {
                    ...formData.fallecido,
                    trasladoId: '0' // Asegurar que se envía trasladoId
                }
            };
            console.log('Payload enviado:', payload); // Depuración
            await axios.post('/permisos', payload);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                {Object.keys(formData).map((key) => (
                    !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) ? (
                        <div className="mb-4" key={key}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={key}
                                value={formData[key]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${key}`}
                            />
                        </div>
                    ) : null
                ))}
                {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                    <div className="mb-4" key={field}>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={field}>
                            {field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                        </label>
                        <input
                            type="text"
                            name={field}
                            value={formData[field]}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            placeholder={`Ingrese ${field}`}
                        />
                    </div>
                ))}
                {Object.keys(formData.fallecido).map((subKey) => (
                    !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones', 'trasladoId'].includes(subKey) && (
                        <div className="mb-4" key={subKey}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={`fallecido.${subKey}}`}>
                                {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={`fallecido.${subKey}`}
                                value={formData.fallecido[subKey]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${subKey}`}
                            />
                        </div>
                    )
                ))}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '', // Campo único
        fecha: '',
        funeraria: '', // Campo único
        horaDefuncion: '', // Campo único
        observaciones: '', // Campo único
        idLinea: '1',
      //  trasladoId: '0',
        fallecido: {
            idLinea: '1',
            fechaFallecimiento: '',
            incidencias: '',
            historico: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedFormData = { ...formData };

        if (name.startsWith('fallecido.')) {
            const key = name.split('.')[1];
            updatedFormData = {
                ...formData,
                fallecido: { ...formData.fallecido, [key]: value }
            };
        } else {
            updatedFormData = { ...formData, [name]: value };
            if (['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(name)) {
                updatedFormData.fallecido[name] = value;
            }
        }

        setFormData(updatedFormData);
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await axios.post('/permisos', formData);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                {Object.keys(formData).map((key) => (
                    !['fallecido', 'terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(key) ? (
                        <div className="mb-4" key={key}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={key}
                                value={formData[key]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${key}`}
                            />
                        </div>
                    ) : null
                ))}
                {['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].map((field) => (
                    <div className="mb-4" key={field}>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={field}>
                            {field.replace(/([A-Z])/g, ' $1').toUpperCase()}
                        </label>
                        <input
                            type="text"
                            name={field}
                            value={formData[field]}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            placeholder={`Ingrese ${field}`}
                        />
                    </div>
                ))}
                {Object.keys(formData.fallecido).map((subKey) => (
                    !['terceroId', 'funeraria', 'horaDefuncion', 'observaciones'].includes(subKey) && (
                        <div className="mb-4" key={subKey}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={`fallecido.${subKey}`}>
                                {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={`fallecido.${subKey}`}
                                value={formData.fallecido[subKey]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${subKey}`}
                            />
                        </div>
                    )
                ))}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/*import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '', // Campo único
        fecha: '',
        funeraria: '',
        horaDefuncion: '',        
        observaciones: '',
        idLinea: '1',
        trasladoId: '0',
        fallecido: {
            idLinea: '1',
            fechaFallecimiento: '',
            funeraria: '',
            horaDefuncion: '',
            incidencias: '',
            historico: '',
            observaciones: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedFormData = { ...formData };

        if (name.startsWith('fallecido.')) {
            const key = name.split('.')[1];
            updatedFormData = {
                ...formData,
                fallecido: { ...formData.fallecido, [key]: value }
            };
        } else {
            updatedFormData = { ...formData, [name]: value };
            if (name === 'terceroId') {
                updatedFormData.fallecido.terceroId = value;
            }
        }

        setFormData(updatedFormData);
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await axios.post('/permisos', formData);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                {Object.keys(formData).map((key) => (
                    key !== 'fallecido' && key !== 'terceroId' ? (
                        <div className="mb-4" key={key}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={key}
                                value={formData[key]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${key}`}
                            />
                        </div>
                    ) : null
                ))}
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                        TERCERO ID
                    </label>
                    <input
                        type="text"
                        name="terceroId"
                        value={formData.terceroId}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Ingrese Tercero ID"
                    />
                </div>
                {Object.keys(formData.fallecido).map((subKey) => (
                    subKey !== 'terceroId' && (
                        <div className="mb-4" key={subKey}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={`fallecido.${subKey}`}>
                                {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={`fallecido.${subKey}`}
                                value={formData.fallecido[subKey]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${subKey}`}
                            />
                        </div>
                    )
                ))}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '',
        horaDefuncion: '',        
        observaciones: '',
        idLinea: '1',
        trasladoId: '0',
        fallecido: {
            idLinea: '1',
            terceroId: '',
            fechaFallecimiento: '',
            funeraria: '',
            horaDefuncion: '',
            incidencias: '',
            historico: '',
            observaciones: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedFormData = { ...formData };
        
        if (name.startsWith('fallecido.')) {
            const key = name.split('.')[1];
            updatedFormData = {
                ...formData,
                [key]: value, // Sincroniza con el objeto principal
                fallecido: { ...formData.fallecido, [key]: value }
            };
        } else if (formData.fallecido.hasOwnProperty(name)) {
            updatedFormData = {
                ...formData,
                [name]: value,
                fallecido: { ...formData.fallecido, [name]: value }
            };
        } else {
            updatedFormData = { ...formData, [name]: value };
        }

        setFormData(updatedFormData);
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await axios.post('/permisos', formData);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                {Object.keys(formData).map((key) => (
                    key !== 'fallecido' ? (
                        <div className="mb-4" key={key}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={key}
                                value={formData[key]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${key}`}
                            />
                        </div>
                    ) : Object.keys(formData.fallecido).map((subKey) => (
                        <div className="mb-4" key={subKey}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={`fallecido.${subKey}`}>
                                {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={`fallecido.${subKey}`}
                                value={formData.fallecido[subKey]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${subKey}`}
                            />
                        </div>
                    ))
                ))}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/
/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '',
        horaDefuncion: '',        
        observaciones: '',
        idLinea: '1',
        trasladoId: '0',
        fallecido: {
            idLinea: '1',
            terceroId: '',
            fechaFallecimiento: '',
            funeraria: '',
            horaDefuncion: '',
            incidencias: '',
            historico: '',
            observaciones: '',
            trasladoId: '0'
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name.startsWith('fallecido.')) {
            const key = name.split('.')[1];
            setFormData({
                ...formData,
                fallecido: { ...formData.fallecido, [key]: value }
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsLoading(true);
        try {
            await axios.post('/permisos', formData);
            navigate('/home/permisos');
        } catch (err) {
            console.error('Error saving permiso:', err);
            setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                {Object.keys(formData).map((key) => (
                    key !== 'fallecido' ? (
                        <div className="mb-4" key={key}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                {key.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={key}
                                value={formData[key]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${key}`}
                            />
                        </div>
                    ) : Object.keys(formData.fallecido).map((subKey) => (
                        <div className="mb-4" key={subKey}>
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={`fallecido.${subKey}`}>
                                {subKey.replace(/([A-Z])/g, ' $1').toUpperCase()}
                            </label>
                            <input
                                type="text"
                                name={`fallecido.${subKey}`}
                                value={formData.fallecido[subKey]}
                                onChange={handleChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder={`Ingrese ${subKey}`}
                            />
                        </div>
                    ))
                ))}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddPermisoForm() {
    const [formData, setFormData] = useState({
        sepulturaId: '',
        terceroId: '',
        fecha: '',
        funeraria: '',
        horaDefuncion: '',
        observaciones: '',
        idLinea: '',
        fallecido: {
            idLinea: '',
            terceroId: '',
            fechaFallecimiento: '',
            funeraria: '',
            horaDefuncion: '',
            incidencias: '',
            historico: '',
            observaciones: '',
            trasladoId: ''
        }
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name.includes("fallecido.")) {
            const key = name.split(".")[1];
            setFormData({
                ...formData,
                fallecido: { ...formData.fallecido, [key]: value }
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = {};
        if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
        if (!formData.funeraria) validationErrors.funeraria = 'El campo Funeraria es obligatorio.';
        if (!formData.horaDefuncion) validationErrors.horaDefuncion = 'El campo Hora Defunción es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/permisos', {
                    sepulturaId: parseInt(formData.sepulturaId, 10),
                    terceroId: formData.terceroId,
                    fecha: formData.fecha,
                    funeraria: formData.funeraria,
                 //   horaDefuncion: formData.horaDefuncion,
                    horaDefuncion:formData.fecha,
                 //   observaciones: formData.observaciones || '',
                      observaciones: formData.funeraria ,
                 //   idLinea: parseInt(formData.idLinea, 10) || 0,
                    idLinea:0,
                    fallecido: {
                       // idLinea: parseInt(formData.fallecido.idLinea, 10) || 0,
                        idLinea:0,
                        terceroId: formData.terceroId,
                      //  fechaFallecimiento: formData.fallecido.fechaFallecimiento,
                        fechaFallecimiento:formData.fecha,
                        funeraria: formData.funeraria,
                      //  horaDefuncion: formData.fallecido.horaDefuncion,
                        horaDefuncion:formData.fecha,
                      //  incidencias: formData.fallecido.incidencias || '',
                        incidencias: formData.funeraria,
                      //  historico: formData.fallecido.historico || '',
                        historico: formData.funeraria,
                    //    observaciones: formData.fallecido.observaciones || '',
                        observaciones: formData.funeraria,
                     //   trasladoId: parseInt(formData.fallecido.trasladoId, 10) || 0
                          trasladoId:0
                    }
                });
                navigate('/home/permisos');
            } catch (err) {
                console.error('Error saving permiso:', err);
                setErrors({ submit: 'Error al guardar el permiso. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Permiso</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="sepulturaId">Sepultura ID</label>
                    <input type="text" name="sepulturaId" value={formData.sepulturaId} onChange={handleChange} className="shadow border rounded w-full py-2 px-3 text-gray-700" />
                    {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">Tercero ID</label>
                    <input type="text" name="terceroId" value={formData.terceroId} onChange={handleChange} className="shadow border rounded w-full py-2 px-3 text-gray-700" />
                    {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">Fecha</label>
                    <input type="date" name="fecha" value={formData.fecha} onChange={handleChange} className="shadow border rounded w-full py-2 px-3 text-gray-700" />
                    {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="funeraria">Funeraria</label>
                    <input type="text" name="funeraria" value={formData.funeraria} onChange={handleChange} className="shadow border rounded w-full py-2 px-3 text-gray-700" />
                    {errors.funeraria && <p className="text-red-500 text-xs italic">{errors.funeraria}</p>}
                </div>
                <div className="flex items-center justify-between">
                    <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" disabled={isLoading}>
                        {isLoading ? 'Guardando...' : 'Guardar Permiso'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/